import axios from "axios";
import cookie from "js-cookie";
import { Loading, Message } from "element-ui";
// import store from '../store/index'

// 参数不全(400), 请求通过(200), 请求出错(401), 未找到资源(404), 非法请求(201), 程序错误(500)，登录过期(201);
const API__code = {
  SUCCESS: "200", //成功
  ERROR401: "401", //请求出错(用户名已注册)
  LOGONEXPIRES: "403", //登录过期
  ERROR500: "500", //服务器异常
  NOAUTH: "505", //无权限
};

// 全局配置的默认值
// axios.defaults.baseURL = 'http://192.168.100.84:6688';
// axios.defaults.headers.common['Data'] = '';
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";

// 超时时间
// axios.defaults.timeout = 5000;
//HTTPrequest拦截
axios.interceptors.request.use(
  (config) => {
    const meta = config.meta || {};
    const token = cookie.get("dnnyptadmin_token");
    const checkCode = cookie.get("dnnyptadmin_checkCode");
    config.params = {
      token: token,
      checkCode: checkCode
    }
    // config.headers["token"] = token; // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    // config.headers["checkCode"] = checkCode; // 让每个请求携带token--['Authorization']为自定义key 请根据实际情况自行修改
    //headers中配置serialize为true开启序列化
    if (config.method === "post" && meta.isSerialize === true) {
      config.data = serialize(config.data);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// http响应拦截器
axios.interceptors.response.use(
  (res) => {
    // console.log('----axios------res--------------');
    // console.log(res);
    if (res.data.code == API__code.LOGONEXPIRES) {
      // store.dispatch('logout', 1); //1:登录状态失效，需重新登录
      // this.$router.push('/loginAdmin');
      location.replace("/loginAdmin");
    }
    // if(res.data.code == API__code.ERROR500) {
    //   window.location = '/500';
    // }
    return res;
  },
  (error) => {
    // window.location = '/500';
    return Promise.reject(error);
  }
);

import API__basic from "./upload.js";

import API__login from "./login.js";

import API_Product from "./product.js";

import API__account from "./account.js";

import API_trial from "./trial.js";

import API_Common from "./common";

import API_Models from "./models";

import API_Admin from "./admin";

import API_User from "./user";

import API_Menu from "./menu";

import API_Urls from "./urls";

import API_Order from "./order";

import API_AIRilab from './AIRilab'

import API_AIPdf from './AIPdf'

import API_Auth from "./authorize";

import API_userCom from "./userCom";

import API_control from "./Management";

import API_Stat from "./statistics";

import API_Man from "./manage";

import API_Integral from "./integral";

import API_ActivityWarn from "./activityWarn";

import API__common from "./basic";

import API__Position from "./positionApi";

import API__DailyStatistic from "./dailyStatistics";

//const imgURLs = 'http://192.168.100.230:8080/dnnCloud/';
const imgURLs = "http://106.14.238.88:8080/dnnCloud/";
export {
  API__code,
  // imgURL,
  imgURLs,
  API__login,
  API__basic,
  API__account,
  API_trial,
  API_Common,
  API_Models,
  API_Admin,
  API_User,
  API_Menu,
  API_Urls,
  API_Product,
  API_Order,
  API_AIRilab,
  API_AIPdf,
  API_Auth,
  API_userCom,
  API_control,
  API_Stat,
  API_Man,
  API_Integral,
  API_ActivityWarn,
  API__common,
  API__Position,
  API__DailyStatistic,
};



// WEBPACK FOOTER //
// ./src/api/index.js